export default __webpack_public_path__ + "static/media/livelinklist-logo.0208fb63.svg";